import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Base } from "@/atoms-react/text/Text.react";
import { levelBronzeFormDataType } from "@/features/flow/types";
import { bronzeFormStyle } from "./bronze-form-style";
import { BronzeFormInputText } from "./items/bronze-form-input-text";
import { BronzeFormUploadDocument } from "./items/bronze-form-upload-document";
import { bronzeFormTranslation } from "./utils";

type BronzeFormCareerPathProps = {
  setBronzeFormState: React.Dispatch<React.SetStateAction<levelBronzeFormDataType>>;
  bronzeFormState: levelBronzeFormDataType;
  realIdentityUuid: string;
};

export const BronzeFormCareerPath = memo(
  (props: BronzeFormCareerPathProps) => {
    const t = useTranslation(["pass"]);

    const setCurriculumUuid = (value: string | null) =>
      props.setBronzeFormState((prevState: levelBronzeFormDataType): levelBronzeFormDataType => {
        return { ...prevState, curriculum_algoreg_session_uuid: value };
      });

    const setLinkedinLink = (value: string | null) =>
      props.setBronzeFormState((prevState: levelBronzeFormDataType): levelBronzeFormDataType => {
        return { ...prevState, linkedin_url: value };
      });

    const setCareerPath = (value: string | null) =>
      props.setBronzeFormState((prevState: levelBronzeFormDataType): levelBronzeFormDataType => {
        return { ...prevState, career_path: value };
      });

    return (
      <div className={bronzeFormStyle.container}>
        <Base className={bronzeFormStyle.containerTitle}>
          {bronzeFormTranslation(t, "career_path.title")}
        </Base>
        <Base>{bronzeFormTranslation(t, "career_path.description")}</Base>

        <BronzeFormUploadDocument
          realIdentityUuid={props.realIdentityUuid}
          logicalState={props.bronzeFormState.curriculum_algoreg_session_uuid ?? ""}
          logicalStateSetter={setCurriculumUuid}
          translationKey="career_path.upload_document"
        />
        <BronzeFormInputText
          type="URL"
          placeholder="https://"
          logicalState={props.bronzeFormState.linkedin_url ?? ""}
          logicalStateSetter={setLinkedinLink}
          translationKey="career_path.linkedin_input"
          rows={1}
        />
        <BronzeFormInputText
          type="Text"
          logicalState={props.bronzeFormState.career_path ?? ""}
          logicalStateSetter={setCareerPath}
          translationKey="career_path.career_path_input"
          maxLength={8400}
          rows={3}
        />
      </div>
    );
  },
  (prevProps: BronzeFormCareerPathProps, nextProps: BronzeFormCareerPathProps): boolean => {
    const prevBronzeForm = prevProps.bronzeFormState;
    const nextBronzeForm = nextProps.bronzeFormState;

    return (
      prevBronzeForm.curriculum_algoreg_session_uuid ===
        nextBronzeForm.curriculum_algoreg_session_uuid &&
      prevBronzeForm.linkedin_url === nextBronzeForm.linkedin_url &&
      prevBronzeForm.career_path === nextBronzeForm.career_path
    );
  }
);
